export const RIDE_STATES = {
  upcoming: ['claimed', 'unclaimed', 'checked_in'],
  inProgress: ['in_progress', 'waiting'],
  completed: ['complete', 'completed'],
  canceled: ['canceled'],
  requested: ['requested', 'inactive'],
  paused: ['paused'],
  all: ['checked_in', 'claimed', 'unclaimed', 'in_progress', 'waiting'],
};

export const RIDE_STATES_QUERY = {
  upcoming: 'all',
  completed: 'completed',
  allCanceled: 'all_canceled',
  billableCanceled: 'billable_canceled',
  requested: 'requested',
  removed: 'removed',
};
